import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47f5a25a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "background-line" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "timeline-item-head" }, null, -1))

import { reactive, onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'timeline',
  props: {
    data: { type: Array, required: true },
},
  setup(__props) {

const props = __props

const mockData = reactive([
    {
        date: '2023-12-01',
        type: 'sucess',
        text: 'M0概念阶段',
    },
    {
        date: '2024-02-01',
        type: 'sucess',
        text: 'M1计划阶段',
    },
    {
        date: '2024-04-16',
        type: 'sucess',
        text: 'M2开发阶段',
    },
    {
        date: '2024-06-31',
        type: 'sucess',
        text: 'M3验证阶段',
    },
    {
        date: '2024-08-01',
        type: 'sucess',
        text: 'M4量产阶段',
    },
    {
        date: '2024-10-01',
        type: 'sucess',
        text: 'M5生命周期阶段',
    },
]);

const collect = {
    milestone: [],
    stage: [],
}

function positionCreator(currentDiv: HTMLElement) {
    return {
        left: currentDiv.getBoundingClientRect().left,
        top: currentDiv.getBoundingClientRect().top,
        height: currentDiv.getBoundingClientRect().height,
        width: currentDiv.getBoundingClientRect().width
    };
}

function getDiffrentMonth(startTime: string, endTime: string) {
    const [startYear, startMonth]: any = startTime.split('-');
    const [endYear, endMonth]: any = endTime.split('-');
    const diffrentYear = endYear - startYear;
    if (diffrentYear == 0) return endMonth - startMonth;
    if (diffrentYear == 1) return (12 - startMonth) + endMonth;
    if (diffrentYear > 1) return endMonth + startMonth + (diffrentYear * 12);
}

class TimeLineCollect {
    startTime: string;
    endTime: string;
    ref: HTMLElement;
    constructor(dom: HTMLElement) {
        this.startTime = '';
        this.endTime = '';
        this.ref = dom;
    }
    getLength() {

    }
    getMonthLength() {
        const { width } = positionCreator(this.ref);
        const month = getDiffrentMonth(this.startTime, this.endTime);
        return Math.floor(width / month);
    }
    setPosition() {

    }
}

const timelineRef = ref();

onMounted(() => {
    const timeLineCollect = new TimeLineCollect(timelineRef.value);
    timeLineCollect.startTime = mockData[0].date;
    timeLineCollect.endTime = mockData[5].date;
    const interval = timeLineCollect.getMonthLength()
    const selectList = Array.from(document.querySelectorAll('.timeline-item-wrap'));
    for (let i = 0; i < selectList.length; i++) {
        const left = i * interval;
        selectList[i].setAttribute('style', `left: ${left}px`);
    }

})




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "timeline-wrap",
    ref_key: "timelineRef",
    ref: timelineRef
  }, [
    _hoisted_1,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mockData, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.date,
        class: "timeline-item-wrap"
      }, [
        _hoisted_2,
        _createElementVNode("div", null, _toDisplayString(item.date), 1)
      ]))
    }), 128))
  ], 512))
}
}

})